var _polygon, _path, _circle, _path2, _path3, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.44,83a53.44,53.44,0,0,1,13.07-5.69l2.69-12.94,21.87-.38,3.15,12.84A53.27,53.27,0,0,1,314.48,82l11-7.25,15.73,15.19-6.84,11.3a53.86,53.86,0,0,1,5.68,13.08L353,117l.38,21.86L340.58,142a53.34,53.34,0,0,1-5.22,13.27l7.25,11.05-15.19,15.73-11.3-6.85a53.41,53.41,0,0,1-13.07,5.68l-2.7,12.94-21.86.38-3.15-12.83a53.51,53.51,0,0,1-13.26-5.22L251,183.41l-15.73-15.19,6.85-11.29a53.64,53.64,0,0,1-5.68-13.08l-12.94-2.69-.38-21.87L236,116.14a53.66,53.66,0,0,1,5.22-13.26l-7.24-11L249.14,76.1,260.44,83Zm11.65,29.12a23.46,23.46,0,1,0,33.17-.58A23.45,23.45,0,0,0,272.09,112.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28,57.08a34.26,34.26,0,0,1,8.3-3.61l1.71-8.21L185.16,45l2,8.15a33.83,33.83,0,0,1,8.42,3.31l7-4.6,10,9.64-4.34,7.17a33.84,33.84,0,0,1,3.6,8.3L220,78.7l.25,13.87-8.15,2a33.83,33.83,0,0,1-3.31,8.42l4.6,7-9.64,10-7.17-4.34a34.39,34.39,0,0,1-8.3,3.6l-1.71,8.22-13.87.24-2-8.15a33.83,33.83,0,0,1-8.42-3.31l-7,4.6-10-9.64,4.35-7.17a34,34,0,0,1-3.61-8.3L137.85,94l-.24-13.87,8.15-2a33.83,33.83,0,0,1,3.31-8.42l-4.6-7,9.64-10,7.17,4.35Zm7.4,18.48a14.89,14.89,0,1,0,21-.37A14.9,14.9,0,0,0,168.68,75.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.53,234.24a35.66,35.66,0,0,1,8.73-3.79l1.79-8.64,14.59-.25,2.1,8.56a36.44,36.44,0,0,1,8.86,3.48l7.37-4.83,10.5,10.14-4.57,7.53a36,36,0,0,1,3.79,8.73l8.63,1.8.26,14.59-8.57,2.1a35.73,35.73,0,0,1-3.48,8.85l4.83,7.37-10.13,10.5-7.54-4.57A35.66,35.66,0,0,1,671,299.6l-1.79,8.64-14.59.25-2.1-8.57a35.43,35.43,0,0,1-8.85-3.48l-7.38,4.84-10.49-10.14,4.57-7.54a35.62,35.62,0,0,1-3.8-8.72l-8.63-1.8-.26-14.59,8.57-2.1a35.43,35.43,0,0,1,3.48-8.85l-4.83-7.37L635,229.67l7.54,4.57Zm7.78,19.43a15.65,15.65,0,1,0,22.13-.39A15.66,15.66,0,0,0,650.31,253.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.07,164.53a38.67,38.67,0,0,1,9.49-4.12l2-9.39,15.86-.28,2.28,9.31a38.68,38.68,0,0,1,9.63,3.79l8-5.25,11.41,11-5,8.19a38.67,38.67,0,0,1,4.12,9.49l9.39,2,.28,15.86-9.31,2.29a38.77,38.77,0,0,1-3.79,9.62l5.25,8-11,11.41-8.19-5a38.67,38.67,0,0,1-9.49,4.12L123,245l-15.86.28L104.88,236a38.77,38.77,0,0,1-9.62-3.79l-8,5.25-11.41-11,5-8.2a38.67,38.67,0,0,1-4.12-9.49l-9.39-2L67,190.9l9.31-2.29A38.77,38.77,0,0,1,80.11,179l-5.26-8,11-11.41,8.2,5Zm8.46,21.13a17,17,0,1,0,24.06-.42A17,17,0,0,0,102.53,185.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.37,443.48c0,.15-147.54.26-329.49.26s-329.53-.11-329.53-.26,147.51-.26,329.53-.26S702.37,443.34,702.37,443.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.84,335.07c-1.92-6.55-7-9.92-12.74-10-5.19,1.13-7,6.36-7.42,11.65s1.44,10.48,3.26,15.47q8.77,24,17.53,48.06l14.65-2.2C644.59,376.47,641.1,356.43,634.84,335.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.3,324.62a19.94,19.94,0,0,0-1.69,2.46,16.86,16.86,0,0,0-1.92,7.79A35.74,35.74,0,0,0,621,346.65c1.47,4.32,3.08,9.07,4.78,14.05l8.57,25.58,2.54,7.78.67,2.12a4.09,4.09,0,0,1,.19.75,3.77,3.77,0,0,1-.3-.72c-.19-.52-.44-1.22-.76-2.09-.66-1.87-1.58-4.5-2.7-7.71l-8.73-25.53c-1.68-5-3.27-9.75-4.73-14.08a35.15,35.15,0,0,1-2.21-11.94,16.55,16.55,0,0,1,2.13-7.88A9,9,0,0,1,622.3,324.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.85,396.59a3.84,3.84,0,0,1-.36-.69c-.21-.47-.55-1.14-.92-2-.78-1.78-1.78-4.4-2.85-7.71s-2.15-7.29-3.22-11.75-2.17-9.38-3.36-14.53-2.57-10-4.07-14.31a81.17,81.17,0,0,0-4.74-11.17,60.57,60.57,0,0,0-4.26-7c-.54-.81-1-1.38-1.31-1.8a3.18,3.18,0,0,1-.44-.65,5.34,5.34,0,0,1,.52.58c.32.4.83.95,1.4,1.74a53.2,53.2,0,0,1,4.42,6.93,77.21,77.21,0,0,1,4.88,11.18,145.22,145.22,0,0,1,4.13,14.36c1.17,5.15,2.29,10.06,3.32,14.53s2.08,8.45,3.1,11.76,2,5.94,2.67,7.74c.34.91.65,1.6.83,2.07A3.69,3.69,0,0,1,646.85,396.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.11,349.73c0,.14-.75.49-1.76.78s-1.87.41-1.91.27.75-.5,1.76-.79S618.07,349.58,618.11,349.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.14,339.75a7.29,7.29,0,0,1-2.47.37,7.54,7.54,0,0,1-2.5,0,8.57,8.57,0,0,1,5-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.43,330.51c-.09.12-.91-.37-1.83-1.09s-1.59-1.39-1.5-1.51.91.37,1.83,1.09S617.52,330.39,617.43,330.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.58,321.84c.15,0,.13.74.15,1.61s0,1.58-.12,1.61-.42-.68-.43-1.6S621.43,321.81,621.58,321.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.91,325.47c.12.08-.21.82-.74,1.65s-1.07,1.44-1.19,1.36.2-.82.74-1.65S630.78,325.39,630.91,325.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.28,335.57c.06.14-.68.61-1.66,1.06s-1.83.69-1.89.56.68-.61,1.66-1.06S637.22,335.43,637.28,335.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.32,346.06a6.74,6.74,0,0,1-4.83,1.31,9.12,9.12,0,0,1,2.4-.72A9.62,9.62,0,0,1,641.32,346.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.62,343.71c-.15,0-.07-.78.16-1.65s.55-1.55.69-1.51.07.78-.16,1.65S624.76,343.75,624.62,343.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.47,357a5.07,5.07,0,0,1,.58-2.23c.45-1.19.94-2.1,1.08-2.05a5.07,5.07,0,0,1-.58,2.24C628.09,356.11,627.61,357,627.47,357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.9,360.86a5.28,5.28,0,0,1-2.13-.38c-1.15-.31-2.07-.59-2-.74s1-.1,2.18.22S622,360.72,621.9,360.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.64,371.62c.09.12-.52.74-1.36,1.39s-1.59,1.09-1.68,1,.51-.74,1.35-1.4S625.54,371.5,625.64,371.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.72,382.37c0,.14-.73.49-1.72.77s-1.82.4-1.86.25.73-.49,1.71-.77S628.67,382.22,628.72,382.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642,355.12c.09.12-.56.68-1.52,1.09s-1.8.48-1.83.33.71-.45,1.62-.83S641.89,355,642,355.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.7,371.93c-.05.14-.86-.07-1.79-.46s-1.64-.83-1.59-1,.87.07,1.8.47S644.76,371.79,644.7,371.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.81,383.87a5.71,5.71,0,0,1-2.37-.53c-1.26-.44-2.24-.9-2.19-1a5.63,5.63,0,0,1,2.37.54A5.54,5.54,0,0,1,648.81,383.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.77,394.13c-.08-.14.86-.83,1.94-1.75s1.91-1.74,2-1.64-.55,1.1-1.68,2.05A5,5,0,0,1,629.77,394.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.08,387.59c-.15,0-.39-.78-.8-1.71s-.82-1.65-.7-1.75.76.53,1.2,1.54S639.22,387.58,639.08,387.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,373.16c-.08.12-.71-.15-1.41-.6s-1.18-.93-1.1-1.06.71.15,1.4.6S636,373,636,373.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.7,361.16c0,.14-.82.49-2,.61a3.34,3.34,0,0,1-2-.18c0-.15.9-.24,2-.36S646.66,361,646.7,361.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.59,352.43c0,.15-.89.21-1.87-.2s-1.57-1.06-1.47-1.17.78.31,1.68.67S647.6,352.28,647.59,352.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.28,376.32c0,.15-.76.17-1.65.05S646,376,646,375.89s.76-.17,1.66-.05S649.3,376.18,649.28,376.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.2,360.28c-.11.11-.84-.43-1.64-1.2s-1.37-1.49-1.26-1.6.84.43,1.64,1.21S676.3,360.18,676.2,360.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.13,327.22c.45-3.29.86-6.66.12-9.89s-2.89-6.33-6.06-7.31c-3.62-1.11-7.62.86-10,3.82s-3.43,6.71-4.39,10.37a378.3,378.3,0,0,0-11.93,77.15l14.89,3.54C695,378.44,699.3,355,703.13,327.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.11,309.71s0,.08-.1.23-.18.4-.31.66l-1.25,2.52c-.26.54-.6,1.13-.89,1.81s-.61,1.43-.95,2.22-.71,1.65-1.09,2.55-.69,1.89-1.06,2.92a130.7,130.7,0,0,0-4.33,14.66c-1.35,5.6-2.48,11.83-3.52,18.4-2,13.15-3.27,25.14-4.42,33.79-.57,4.32-1.05,7.82-1.45,10.23l-.45,2.77c0,.29-.09.53-.13.72a1,1,0,0,1-.06.25.75.75,0,0,1,0-.26c0-.19,0-.43.07-.72.09-.68.21-1.61.35-2.79.33-2.41.76-5.92,1.28-10.25,1.06-8.65,2.25-20.65,4.27-33.82,1-6.58,2.19-12.83,3.57-18.44a123.58,123.58,0,0,1,4.45-14.68c.38-1,.75-2,1.1-2.91l1.13-2.54c.36-.79.69-1.53,1-2.21s.66-1.26.94-1.8l1.35-2.47c.14-.26.26-.46.36-.64S695.1,309.7,695.11,309.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.5,309.85a10.78,10.78,0,0,1,1.55,3.29,23.23,23.23,0,0,1,.46,9.9c-1.19,8.3-3,19.72-5.2,32.32s-4.38,24-6,32.17c-.84,4.1-1.54,7.42-2,9.71l-.6,2.63c-.06.27-.12.49-.16.68a.74.74,0,0,1-.08.23.87.87,0,0,1,0-.24l.12-.69c.12-.66.28-1.54.49-2.66.45-2.35,1.09-5.66,1.87-9.74,1.58-8.22,3.7-19.6,5.89-32.19s4.08-24,5.36-32.27a23.76,23.76,0,0,0-.28-9.79A20,20,0,0,0,696.5,309.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.29,349.9a8.58,8.58,0,0,1-2.79-1,8.44,8.44,0,0,1-2.56-1.5,8,8,0,0,1,2.79,1A8.14,8.14,0,0,1,703.29,349.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.56,334.68a9.06,9.06,0,0,1-2.87,1.26,9.43,9.43,0,0,1-3,.75,9.06,9.06,0,0,1,2.87-1.26A9.43,9.43,0,0,1,706.56,334.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.8,322a4.79,4.79,0,0,1-2.27-.1,4.88,4.88,0,0,1-2.17-.63,5.07,5.07,0,0,1,2.26.1A4.89,4.89,0,0,1,706.8,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,312.53c-.14.07-.72-.82-1.31-2s-.95-2.15-.81-2.22.71.82,1.3,2A5.5,5.5,0,0,1,692,312.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.12,319.64a4.46,4.46,0,0,1-2.17,0c-1.18-.14-2.12-.37-2.1-.52a4.43,4.43,0,0,1,2.16,0A4.58,4.58,0,0,1,686.12,319.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681,334.48a5.35,5.35,0,0,1-2.2-.83c-1.14-.59-2-1.18-1.95-1.32a5.24,5.24,0,0,1,2.2.84C680.19,333.76,681.06,334.35,681,334.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.39,347.22c0,.14-.87.37-2,.49s-2,.11-2,0,.88-.37,2-.5S679.38,347.07,679.39,347.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.69,368c0,.15-.93.35-2.1.44a4.44,4.44,0,0,1-2.15-.09c0-.15.93-.35,2.1-.45A4.51,4.51,0,0,1,675.69,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.45,379.37c0,.14-.76.61-1.82,1.05s-2,.68-2,.54.76-.61,1.82-1S673.39,379.23,673.45,379.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.63,393.35a6.35,6.35,0,0,1-1.29-2.18,6.09,6.09,0,0,1-.79-2.41,11.67,11.67,0,0,1,2.08,4.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.4,371.85c.09.12-.73.94-1.84,1.84s-2.08,1.54-2.18,1.42.73-.94,1.84-1.84S686.3,371.73,686.4,371.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.87,360.38c-.12.09-.75-.54-1.41-1.4s-1.1-1.64-1-1.73.75.54,1.41,1.4S687,360.29,686.87,360.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.11,346c.1.11-.59.92-1.56,1.81s-1.82,1.52-1.92,1.41.59-.92,1.56-1.81S690,345.86,690.11,346Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.16,335.48c-.11.1-.91-.66-1.78-1.69s-1.47-1.94-1.36-2,.91.66,1.78,1.69S692.28,335.39,692.16,335.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.58,321.37c.12.09-.41,1-1.17,2.05s-1.48,1.82-1.6,1.73.4-1,1.16-2S695.45,321.28,695.58,321.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.71,308.48c.13.08-.35,1-1.05,2.06s-1.38,1.85-1.51,1.76.35-1,1.06-2.06S700.59,308.39,700.71,308.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.55,314.91c.06.14-.59.51-1.43.82s-1.58.45-1.63.31.59-.51,1.44-.82S704.5,314.77,704.55,314.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.18,362.54a9.17,9.17,0,0,1-5.29-2.87,15.49,15.49,0,0,1,2.66,1.4A15.93,15.93,0,0,1,700.18,362.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.42,372.46c0,.15-.92.36-2.09.48s-2.13.08-2.14-.07.92-.36,2.09-.47S697.41,372.31,697.42,372.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.58,389.55a8.64,8.64,0,0,1-3.3-5.07,17.47,17.47,0,0,1,1.65,2.54A17.8,17.8,0,0,1,693.58,389.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.58,395.17c-.09-.12.59-.75,1.51-1.4s1.74-1.07,1.82-.95-.59.75-1.51,1.4S668.66,395.29,668.58,395.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.52,349.59c-.6-3.63-2.09-8-5.72-8.57a6.12,6.12,0,0,0-5.62,2.68,12.69,12.69,0,0,0-2.31,6.07A165.39,165.39,0,0,0,653,396.36l13.32,1.95A159.84,159.84,0,0,0,665.52,349.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.8,341a14.48,14.48,0,0,0-1.41,1.72,12.52,12.52,0,0,0-1.49,5.8c-.11,2.57-.27,5.66-.33,9.06s0,7.17.19,11.1c.39,7.88,1.08,15,1.42,20.15.18,2.58.29,4.68.35,6.12,0,.67,0,1.22,0,1.67a.29.29,0,1,1-.12,0l-.15-1.65c-.14-1.54-.32-3.6-.54-6.1-.46-5.15-1.22-12.26-1.6-20.16-.19-3.94-.24-7.71-.15-11.14,0-1.71.13-3.34.21-4.86s.14-2.93.26-4.22a12.16,12.16,0,0,1,1.72-5.9A5.32,5.32,0,0,1,659.8,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.73,345.06c.08.15-.69.72-1.73,1.28s-1.94.87-2,.72.7-.72,1.73-1.27S666.65,344.91,666.73,345.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669,356a3.72,3.72,0,0,1-2.39-.11c-1.3-.33-2.22-.92-2.15-1.07s1.07.16,2.3.47S669,355.78,669,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.77,367.26c-.11.13-1.06-.5-2.12-1.4s-1.82-1.74-1.71-1.87,1.06.49,2.11,1.4S668.88,367.13,668.77,367.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.89,
    y: 391.72,
    width: 77.06,
    height: 13.66,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.65 402.67 638.02 443.48 683.95 443.48 694.2 402.67 628.65 402.67",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.91,405.39c0,.15-17.38.27-38.82.27s-38.82-.12-38.82-.27,17.38-.27,38.82-.27S699.91,405.24,699.91,405.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.39,357.55c-.16.07-.65-.71-1.1-1.74s-.69-1.91-.53-2,.65.71,1.1,1.74S661.55,357.48,661.39,357.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.61,369.92c-.15-.08.2-1.09.79-2.27s1.2-2.06,1.35-2-.2,1.09-.8,2.27S659.76,370,659.61,369.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.94,383.52c-.17.05-.66-1.08-1.11-2.53a6.42,6.42,0,0,1-.52-2.71,12.36,12.36,0,0,1,1.63,5.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.44,389.15c-.11-.13.56-.83,1.48-1.57s1.77-1.21,1.87-1.08-.56.84-1.48,1.57S648.55,389.28,648.44,389.15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.63,
    y: 135.8,
    width: 454.85,
    height: 300.79,
    rx: 14.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.85,417.16h492.8a0,0,0,0,1,0,0v8.52a17.8,17.8,0,0,1-17.8,17.8H150.65a17.8,17.8,0,0,1-17.8-17.8v-8.52a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.21 414.34 339.33 424.07 425.38 424.07 431.06 414.34 333.21 414.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.67,
    y: 156.35,
    width: 412.36,
    height: 244.6,
    rx: 3.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.6 401.31 171.23 401.31 171.68 174.63 583.6 174.63 583.6 401.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5,165.8a3.3,3.3,0,1,1-3.3-3.3A3.29,3.29,0,0,1,205.5,165.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.54,165.8a3.3,3.3,0,1,1-3.3-3.3A3.29,3.29,0,0,1,185.54,165.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12,165.8a3.3,3.3,0,1,1-3.3-3.3A3.29,3.29,0,0,1,195.12,165.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.57,414.34c0,.17-101,.3-225.46.3s-225.48-.13-225.48-.3,100.93-.29,225.48-.29S601.57,414.18,601.57,414.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.31,376.28h-6a.5.5,0,0,1,0-1h5.5v-5.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v6A.5.5,0,0,1,524.31,376.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.64,376.28H495a.5.5,0,0,1,0-1h11.66a.5.5,0,0,1,0,1Zm-23.33,0H471.65a.5.5,0,0,1,0-1h11.66a.5.5,0,0,1,0,1Zm-23.33,0H448.32a.5.5,0,1,1,0-1H460a.5.5,0,0,1,0,1Zm-23.33,0H425a.5.5,0,0,1,0-1h11.66a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,376.28h-6a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v5.5h5.5a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.32,357.78a.51.51,0,0,1-.5-.5V344.77a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.51A.5.5,0,0,1,407.32,357.78Zm0-25a.5.5,0,0,1-.5-.5v-12.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.5A.5.5,0,0,1,407.32,332.76Zm0-25a.51.51,0,0,1-.5-.5V294.75a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.51A.5.5,0,0,1,407.32,307.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.32,282.74a.5.5,0,0,1-.5-.5v-6a.51.51,0,0,1,.5-.5h6a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-5.5v5.5A.5.5,0,0,1,407.32,282.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.64,276.74H495a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.66a.5.5,0,0,1,.5.5A.5.5,0,0,1,506.64,276.74Zm-23.33,0H471.65a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.66a.5.5,0,0,1,.5.5A.5.5,0,0,1,483.31,276.74Zm-23.33,0H448.32a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H460a.5.5,0,0,1,.5.5A.5.5,0,0,1,460,276.74Zm-23.33,0H425a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.66a.5.5,0,0,1,.5.5A.5.5,0,0,1,436.65,276.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.31,282.74a.5.5,0,0,1-.5-.5v-5.5h-5.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6a.51.51,0,0,1,.5.5v6A.5.5,0,0,1,524.31,282.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.31,357.78a.5.5,0,0,1-.5-.5V344.77a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.51A.51.51,0,0,1,524.31,357.78Zm0-25a.5.5,0,0,1-.5-.5v-12.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.5A.5.5,0,0,1,524.31,332.76Zm0-25a.5.5,0,0,1-.5-.5v-12.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.5A.5.5,0,0,1,524.31,307.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408,72.32a17.45,17.45,0,0,0,.38,16.19c1.35,2.36,3.36,4.84,2.63,7.48s-3.88,4-4.51,6.67c-.74,3.11,2.34,5.74,3,8.84a6.35,6.35,0,0,1-4.11,7.11,24.79,24.79,0,0,0,13.34-.47c.41-1.81.83-3.61,1.24-5.42-.52,1.94.83,4,2.63,4.87a10.44,10.44,0,0,0,5.92.54,31.68,31.68,0,0,0,23-15.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.82,72c-1.5-1.59-3.37-2.84-4.7-4.58-2.85-3.74-3-9.39-6.81-12.18-2.71-2-6.41-1.83-9.75-1.34s-6.84,1.22-10,.12c-2.34-.8-4.26-2.52-6.58-3.33-3.32-1.16-7-.33-10.31,1a21.35,21.35,0,0,0-8.87,6.09,11.54,11.54,0,0,0-2.46,10.13c.48,1.69,1.44,3.24,1.65,5,.24,1.92-.47,3.83-.55,5.76a9.16,9.16,0,0,0,6.81,9l36,18.16c5.55-.47,16-8,18-13.21S468.63,76,464.82,72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,83.7c-2.15-7-.77-17.08,6.34-19l23.38-2.82A4.25,4.25,0,0,1,447,64.57l17.77,50a.92.92,0,0,0,1.41-.15.3.3,0,0,1,.52.25c-.78,4.64.13,15.48-13.87,16.4-3.13.2-9.28.45-11-2.46l-3.32-8c-1.62-4.11-2.26-5.8-2.24-5.76s-9.32,1.91-15.44-8.75C417.73,100.81,414.5,91.45,412.11,83.7Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.43,92.75a1.56,1.56,0,0,0,2,.93,1.5,1.5,0,0,0,1-1.89,1.56,1.56,0,0,0-2-.93A1.5,1.5,0,0,0,419.43,92.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6,87.42a1.55,1.55,0,0,0,2,.92,1.49,1.49,0,0,0,1-1.89,1.56,1.56,0,0,0-2-.93A1.51,1.51,0,0,0,433.6,87.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,88.16c.27.18,1.2-1.27,3-1.81s3.35.08,3.47-.23c.06-.14-.28-.52-1-.82a4.19,4.19,0,0,0-2.86-.12,4.24,4.24,0,0,0-2.27,1.74C415.36,87.58,415.31,88.08,415.44,88.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,82.91c.31.14,1.16-1.4,3-2.17s3.54-.36,3.64-.68c.05-.15-.34-.48-1.1-.68a4.7,4.7,0,0,0-3,.26,4.63,4.63,0,0,0-2.24,2C430.82,82.34,430.81,82.85,431,82.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.27,95.9a11,11,0,0,0-2.74.52c-.42.11-.83.18-1-.07a2.08,2.08,0,0,1-.18-1.28c0-1.12,0-2.28,0-3.51,0-5-.14-9-.34-9s-.38,4-.39,9c0,1.22,0,2.38,0,3.5a2.48,2.48,0,0,0,.39,1.65,1.1,1.1,0,0,0,.89.33,3.31,3.31,0,0,0,.72-.17A11.64,11.64,0,0,0,430.27,95.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.21,114.86A31.43,31.43,0,0,0,450,104.93s-.82,9.44-12.67,12.77Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.58,99.46a3.07,3.07,0,0,1,2.55-1.5,2.78,2.78,0,0,1,2,.73,1.73,1.73,0,0,1,.4,2,2,2,0,0,1-2.11.87,6.39,6.39,0,0,1-2.31-1,1.78,1.78,0,0,1-.55-.43.54.54,0,0,1-.08-.61",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.68,96.13c-.27.08.37,1.79-.63,3.55s-2.91,2.29-2.83,2.53.53.17,1.31-.1a4.65,4.65,0,0,0,2.4-2,4,4,0,0,0,.41-2.94C436.14,96.42,435.79,96.08,435.68,96.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,78c.38.3,1.71-.77,3.52-1.61S435,75.16,435,74.67c0-.23-.47-.44-1.25-.48a6.45,6.45,0,0,0-2.94.65,6.61,6.61,0,0,0-2.38,1.87C428,77.34,427.86,77.84,428,78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,83.36c.46.27,1.78-.49,3.47-1s3.21-.6,3.44-1.07c.1-.23-.23-.54-.95-.71a6.44,6.44,0,0,0-5.57,1.64C413.42,82.79,413.33,83.23,413.53,83.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,61.36c-1.75-1.08-4-1-6-.85a112.53,112.53,0,0,0-26.19,5.16c-.23,2.1,1.73,3.88,3.8,4.35s4.21,0,6.32-.15,4.45,0,6,1.38,2.05,4,3.64,5.6c2.73,2.72,7.85,1.59,10.57,4.33,2.05,2.06,1.85,5.4,2.71,8.18a10.57,10.57,0,0,0,6.72,6.79,10.73,10.73,0,0,0,7.66-.48l-11.64-29C449.81,64.64,448.89,62.49,447,61.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.35,76.09c-2.13-.62-4.55-.89-6-2.51-2.18-2.36-1.47-6.69-4.11-8.54-2.4-1.68-6.24.28-8.57-1.5-1.83-1.38-1.49-3.53-2.62-5s-4.1-1.77-5.67-.79l-4.19,24.76c1.73,6.82,2.09,10.72,5.16,13.74a31.83,31.83,0,0,1,4.86,5.13c1.29,2,1.87,4.63.72,6.71,8-3.06,13.4-10.52,18.28-17.59l5.17-7.47a5.82,5.82,0,0,0,1.19-2.54C481.77,78.32,479.47,76.71,477.35,76.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.48,88.56a4.33,4.33,0,0,1-.76.55,8,8,0,0,1-2.49,1,8.23,8.23,0,0,1-4.21-.21,7.93,7.93,0,0,1-4.33-3.44,8.32,8.32,0,0,1-1.14-3.07,13.2,13.2,0,0,1,.1-3.54,12.81,12.81,0,0,0,.09-3.66,4.21,4.21,0,0,0-1.95-3.07c-1.15-.6-2.56-.21-4-.12a3.89,3.89,0,0,1-2.22-.43,3.78,3.78,0,0,1-1.48-1.76,24.1,24.1,0,0,1-1-4.42,4.63,4.63,0,0,0-.91-2,3,3,0,0,0-1.85-1,8.55,8.55,0,0,0-4.41.81,9.36,9.36,0,0,1-4.54.73,8.33,8.33,0,0,1-4.12-1.65A13.55,13.55,0,0,1,432.5,60,18.77,18.77,0,0,0,430.11,57a8.27,8.27,0,0,0-3.1-1.86,9.67,9.67,0,0,0-10.83,3.39,11.8,11.8,0,0,0-1.92,3.66,14.65,14.65,0,0,0-.61,3.5.6.6,0,0,1,0-.23c0-.16,0-.39,0-.7a11.52,11.52,0,0,1,.44-2.62A11.68,11.68,0,0,1,416,58.31a10,10,0,0,1,11.18-3.62,9,9,0,0,1,3.28,1.94,18.69,18.69,0,0,1,2.46,3.16,13.28,13.28,0,0,0,2.66,3.09,7.76,7.76,0,0,0,3.88,1.53,8.85,8.85,0,0,0,4.32-.7,9,9,0,0,1,4.66-.84,3.51,3.51,0,0,1,2.15,1.2,5.35,5.35,0,0,1,1,2.16,24.35,24.35,0,0,0,1,4.35,3.27,3.27,0,0,0,1.29,1.54,3.4,3.4,0,0,0,1.95.38c.7,0,1.4-.16,2.12-.19a4,4,0,0,1,2.12.38,4.59,4.59,0,0,1,2.17,3.39,12.89,12.89,0,0,1-.11,3.79,12.91,12.91,0,0,0-.13,3.43,7.94,7.94,0,0,0,1.06,3,7.76,7.76,0,0,0,4.12,3.36,8.16,8.16,0,0,0,4.08.28A9.61,9.61,0,0,0,474.48,88.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.58,70.42a1.62,1.62,0,0,1,.55.51A3,3,0,0,1,479.7,73a3.27,3.27,0,0,1-.51,1.5,3.32,3.32,0,0,1-1.45,1.22,4.26,4.26,0,0,1-4.4-.53,5.51,5.51,0,0,1-1.65-2.08,7.66,7.66,0,0,1-.65-2.8c-.17-2,.18-4.1-.71-6.06A3.85,3.85,0,0,0,468.19,62a4.31,4.31,0,0,0-3.23.46,10.66,10.66,0,0,1-3.52,1.24,3.21,3.21,0,0,1-1.92-.5,4.42,4.42,0,0,1-1.36-1.43,14.78,14.78,0,0,1-1.33-3.55,8.23,8.23,0,0,0-1.67-3.08,8.87,8.87,0,0,0-5.82-3,12.61,12.61,0,0,0-5.94,1.33,17.54,17.54,0,0,1-5.27,1.55,11.43,11.43,0,0,1-7.53-2,7.94,7.94,0,0,1-2.07-2,14.93,14.93,0,0,0,2.18,1.85,11.29,11.29,0,0,0,3,1.41,11.11,11.11,0,0,0,4.38.44,17.43,17.43,0,0,0,5.14-1.58,13,13,0,0,1,6.15-1.4,9.22,9.22,0,0,1,6.14,3.12,8.73,8.73,0,0,1,1.77,3.25,14.76,14.76,0,0,0,1.28,3.44,3.17,3.17,0,0,0,2.84,1.7,10.1,10.1,0,0,0,3.34-1.2,4.84,4.84,0,0,1,3.59-.46,4.3,4.3,0,0,1,2.4,2.48,8.23,8.23,0,0,1,.64,3.2c0,1,0,2,.06,3a7.67,7.67,0,0,0,.59,2.67,5.23,5.23,0,0,0,1.52,2,4,4,0,0,0,4.07.56,3.08,3.08,0,0,0,1.36-1.1A2.89,2.89,0,0,0,479.5,73a3,3,0,0,0-.45-2C478.78,70.59,478.56,70.44,478.58,70.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,113.66a3.34,3.34,0,0,0,1,2,2.89,2.89,0,0,0,2.37.86,3.12,3.12,0,0,0,2.49-2.11,2.81,2.81,0,0,0-.1-1.93,5.6,5.6,0,0,0-1.21-1.8c-1-1.11-2.53-2.13-3.2-3.89a6.86,6.86,0,0,1,.27-5.56,8.12,8.12,0,0,1,1.82-2.4,12.25,12.25,0,0,1,2.58-1.7,15.88,15.88,0,0,0,2.54-1.54,4,4,0,0,0,1.49-2.28,4.84,4.84,0,0,0-.32-2.63,9.17,9.17,0,0,0-1.32-2.27,20,20,0,0,1-2.81-4.17,7.48,7.48,0,0,1-.37-4.39,9.77,9.77,0,0,1,1.53-3.31,19.39,19.39,0,0,0,1.37-2.34,5.71,5.71,0,0,0,.5-2.22s0,0,0,.15a2.49,2.49,0,0,1,0,.45,4.59,4.59,0,0,1-.39,1.69A16.07,16.07,0,0,1,406,76.67a10,10,0,0,0-1.42,3.24,7.23,7.23,0,0,0,.41,4.16,20.51,20.51,0,0,0,2.8,4.05,9.48,9.48,0,0,1,1.39,2.38,5.13,5.13,0,0,1,.35,2.89A4.48,4.48,0,0,1,407.92,96a17.25,17.25,0,0,1-2.63,1.6,11.53,11.53,0,0,0-2.48,1.62,7.63,7.63,0,0,0-1.71,2.26,6.38,6.38,0,0,0-.28,5.17c.59,1.62,2,2.61,3.08,3.78a5.89,5.89,0,0,1,1.26,1.94,3.13,3.13,0,0,1,.07,2.17,3.43,3.43,0,0,1-2.79,2.29,3.22,3.22,0,0,1-3.35-2.53A1.62,1.62,0,0,1,399.07,113.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.26,
    y: 210.1,
    width: 122.69,
    height: 98.51,
    rx: 4.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.36,308.61a7.91,7.91,0,0,0,1.1-.17,4.63,4.63,0,0,0,2.62-1.83,4.5,4.5,0,0,0,.79-2.23c0-.88,0-1.87,0-2.92q0-3.18,0-7.31c0-11-.05-26.91-.08-46.56,0-9.83,0-20.59,0-32.15a6.22,6.22,0,0,0-.22-2.08,4.39,4.39,0,0,0-1.08-1.77,4.49,4.49,0,0,0-1.79-1.07,6.81,6.81,0,0,0-2.14-.2H489.42l-84.55,0a4.36,4.36,0,0,0-4.08,2.84,7.11,7.11,0,0,0-.27,2.67v35.39c0,14.14,0,27.79,0,40.78v12a4.44,4.44,0,0,0,.56,2.14,4.39,4.39,0,0,0,3.61,2.2l17.91,0,32.15,0,46.56.09,12.66,0,3.29,0,1.12,0s-.38,0-1.12,0l-3.29,0-12.66,0-46.56.08-32.15,0H404.66A4.81,4.81,0,0,1,400,304v-2.37c0-3.17,0-6.38,0-9.63,0-13,0-26.64,0-40.78q0-10.6,0-21.57V215.87a7.59,7.59,0,0,1,.3-2.85,4.87,4.87,0,0,1,4.57-3.18l84.55,0h28.09a7,7,0,0,1,2.27.21,4.84,4.84,0,0,1,3.16,3.13,6.81,6.81,0,0,1,.23,2.22c0,11.56,0,22.32,0,32.15,0,19.65-.07,35.56-.09,46.56,0,2.75,0,5.19,0,7.31,0,1.06,0,2,0,2.93a4.64,4.64,0,0,1-.83,2.28,4.58,4.58,0,0,1-2.69,1.82A4,4,0,0,1,518.36,308.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.9,
    y: 204.16,
    width: 84.04,
    height: 111.81,
    transform: "translate(199.93 720.89) rotate(-89.76)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "405.84 301.85 445.11 249.78 469.16 282.56 485.64 265.15 517.65 302.32 405.84 301.85"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.59,243.52a8.8,8.8,0,1,1-8.76-8.84A8.8,8.8,0,0,1,479.59,243.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M407.24,136.77s-.62-1.24,2.88-5.15,27.61-12.84,27.61-12.84,9.38,11.34,18.09,3.55a22.89,22.89,0,0,0,7.34-12.54s21.29-1.19,21.74.2l5.7,26.77-10,.05Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,198,495,161l-4.72-20.24,19.94-5.87s5.9,28.28,5.11,33.25c-1.53,9.64-47,37.17-47,37.17Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.87,109.59a27,27,0,0,1,16.2,8c7.68,7.91,16.87,28.65,16.87,28.65l-26,6.35Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.25,202.05l-10.41,6.49s-5.24,8.73-6,10.92a61.18,61.18,0,0,0-1.47,7.66s2.26,2.07,3.19-1.12l1.07-2.44-.9,5.68S441,231,442.16,228a36.47,36.47,0,0,0,1.62-5.89l3.55-4.89-3.58,11.68s-.68,2.36,1.41,2.15c.83-.08,2.68-4.2,2.68-4.2s1.52,2,2.79.2l6.19-8.75s6.64-8.2,6.66-8.42c0,0,4.88-4.58,4.88-4.58L458,198l-4.49,3.82A1,1,0,0,1,453.25,202.05Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,229a4.34,4.34,0,0,0,.15-.66c.09-.46.2-1.07.34-1.8s.3-1.68.47-2.68c.09-.51.18-1,.28-1.59a8.42,8.42,0,0,1,.51-1.62,29.77,29.77,0,0,1,3-5.21c.45-.63.83-1.13,1.08-1.48a4.46,4.46,0,0,0,.4-.55,3.09,3.09,0,0,0-.46.5c-.28.33-.68.81-1.14,1.44a26.07,26.07,0,0,0-3.1,5.22,8.65,8.65,0,0,0-.53,1.66c-.09.55-.17,1.08-.25,1.59-.16,1-.31,1.91-.43,2.69l-.27,1.82A3.33,3.33,0,0,0,438.77,229Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.67,216.79a2.43,2.43,0,0,0-.24.34l-.59,1c-.49.83-1.16,2-1.89,3.27h0l-.09.23c-.58,1.43-1.1,2.72-1.46,3.67-.19.47-.33.85-.42,1.12a1.93,1.93,0,0,0-.13.42,1.6,1.6,0,0,0,.21-.39l.48-1.09c.4-.93.94-2.22,1.52-3.65l.09-.23h0c.73-1.29,1.38-2.46,1.83-3.31.23-.42.41-.77.54-1S452.69,216.8,452.67,216.79Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.32,134.26a3.05,3.05,0,0,1,.13.32,5.94,5.94,0,0,1,.32,1.55,4.66,4.66,0,0,0,0,.75,2.53,2.53,0,0,0,.21.44,7.68,7.68,0,0,1,.27,3.09,5.91,5.91,0,0,0,.57,3.31,2.19,2.19,0,0,0,2.91.9,1.48,1.48,0,0,0,1.11,1.62,2.13,2.13,0,0,0,2-.61,4,4,0,0,0,1-1.9,1.64,1.64,0,0,0,1.63,1.59,2.52,2.52,0,0,0,2.08-1.28,5.82,5.82,0,0,0,.72-2.42,27.29,27.29,0,0,1,.51-3.24s1.07.17,1.55.21c.66.07.14,0,.14,0a7.16,7.16,0,0,0,1-1.77c.68-1.4,1.19-2.29,1.71-3.56.39-.95.64-1.9.06-2.52-1.42-1.49-4.19,1.54-4.19,1.54-.39-1.05-3.61-1.23-4.23.18-.26-.77-.16-1.22-.79-1.74a2.6,2.6,0,0,0-2.28-.58,1.86,1.86,0,0,0-1.38,1.79,3,3,0,0,0-5.07-.11,3.05,3.05,0,0,0-.47,1,1.56,1.56,0,0,0-.08.42.62.62,0,0,0,.07.19C394,133.74,394.19,134,394.32,134.26Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.92,132.37A2.44,2.44,0,0,0,389,133a4,4,0,0,0-.6,2.67c1,.19,1.47.22,2.44.41.21,0,.38,0,.55.1.45.32.37,1.39.55,1.91a1.87,1.87,0,0,0,2.36,1,2.51,2.51,0,0,0,1.52-2.23,3.92,3.92,0,0,0-1-2.61A5.45,5.45,0,0,0,390.92,132.37Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.23,131.72c.18,0,.18,2.92,0,6.49s-.48,6.47-.66,6.46-.18-2.92,0-6.49S399.05,131.71,399.23,131.72Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.88,132.36c.18,0,.42,2.63.13,5.89s-1,5.82-1.13,5.78.2-2.63.47-5.84S403.69,132.36,403.88,132.36Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.25,132.36c.18,0,.26,2.2-.08,4.86s-.75,4.79-.92,4.77-.08-2.2.26-4.85S408.07,132.35,408.25,132.36Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.32,132.92c0-.08.47-.18,1.14.12a3.73,3.73,0,0,1,1.79,2.09,7.49,7.49,0,0,1,.44,2.68c-.08.8-.66,1-.68.93s.27-.35.21-1a13.66,13.66,0,0,0-.59-2.42,4,4,0,0,0-1.4-1.92C392.72,133.09,392.31,133,392.32,132.92Z",
    style: {
      fill: "#6f4439"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 289.63,
    width: 158.42,
    height: 88.07,
    rx: 8.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,377.7s.42,0,1.23-.12a8.63,8.63,0,0,0,6.88-5.77,9.88,9.88,0,0,0,.45-3.68c0-1.34,0-2.77,0-4.28,0-12.11-.05-29.61-.08-51.23,0-2.71,0-5.48,0-8.31V300a13.64,13.64,0,0,0-.4-4.28,8.51,8.51,0,0,0-6.21-5.69,9.82,9.82,0,0,0-2.25-.21h-7.06l-40.6,0-93,0a8.5,8.5,0,0,0-5.49,2.05,8.27,8.27,0,0,0-2.8,5.09,21.36,21.36,0,0,0-.11,3v32.83q0,11.69,0,22.92V366.9c0,.9,0,1.84,0,2.72a8.34,8.34,0,0,0,3.88,6.53,8.64,8.64,0,0,0,4.95,1.32h15.57l19.71,0,35.38,0,51.23.08,13.93,0,3.62,0,1.23,0-1.23,0-3.62,0-13.93.05-51.23.08-35.38,0H236.1a9.07,9.07,0,0,1-5.2-1.38,9,9,0,0,1-3.5-4.19,8.74,8.74,0,0,1-.61-2.72c-.06-.94,0-1.83,0-2.75,0-3.67,0-7.37,0-11.11V332.87q0-11.67,0-23.74V300a21.35,21.35,0,0,1,.11-3.08,8.84,8.84,0,0,1,3-5.42,9,9,0,0,1,5.83-2.17l93,0,40.6,0h7.06a10.2,10.2,0,0,1,2.34.22,8.91,8.91,0,0,1,6.5,6,13.79,13.79,0,0,1,.41,4.4v4.29q0,4.24,0,8.31c0,21.62-.07,39.12-.09,51.23,0,1.51,0,2.94,0,4.28a10.2,10.2,0,0,1-.48,3.73,8.61,8.61,0,0,1-3.63,4.55,8.31,8.31,0,0,1-3.39,1.22,5.16,5.16,0,0,1-.93.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.9,
    y: 304.51,
    width: 23.53,
    height: 4.44,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.9,
    y: 358.9,
    width: 23.53,
    height: 4.44,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.9,
    y: 315.52,
    width: 40.51,
    height: 4.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.59,
    y: 315.52,
    width: 17.91,
    height: 4.44,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.08,
    y: 315.52,
    width: 11.77,
    height: 4.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.79,
    y: 315.52,
    width: 31.18,
    height: 4.44,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.34,
    y: 326.01,
    width: 40.51,
    height: 4.44,
    transform: "translate(685.2 656.46) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.26,
    y: 326.01,
    width: 17.91,
    height: 4.44,
    transform: "translate(612.42 656.46) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.9,
    y: 326.01,
    width: 11.77,
    height: 4.44,
    transform: "translate(499.58 656.46) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.79,
    y: 326.01,
    width: 31.18,
    height: 4.44,
    transform: "translate(550.75 656.46) rotate(180)",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.9,
    y: 336.79,
    width: 40.51,
    height: 4.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.59,
    y: 336.79,
    width: 17.91,
    height: 4.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.08,
    y: 336.79,
    width: 11.77,
    height: 4.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.39,
    y: 347.77,
    width: 11.77,
    height: 4.44,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.79,
    y: 336.79,
    width: 31.18,
    height: 4.44,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.05,
    y: 347.77,
    width: 31.18,
    height: 4.44,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.61,
    y: 320.4,
    width: 65.53,
    height: 63.63,
    rx: 8.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,384a10.94,10.94,0,0,0,2.43-.43,8.11,8.11,0,0,0,5-4.67,8.26,8.26,0,0,0,.55-2.34c.06-.84,0-1.75,0-2.69,0-1.88,0-3.93,0-6.12,0-4.4,0-9.4,0-14.92s0-11.59,0-18.09c0-1.62,0-3.28,0-4.95a17.19,17.19,0,0,0-.1-2.5,7.52,7.52,0,0,0-.76-2.38,7.9,7.9,0,0,0-3.59-3.52,7.69,7.69,0,0,0-2.49-.73c-.86-.08-1.79-.05-2.7-.05l-47.56,0a7.82,7.82,0,0,0-7.83,7.61q0,6.17,0,12.13c0,8,0,15.63,0,22.94,0,3.66,0,7.22,0,10.68,0,.86,0,1.75,0,2.56a8.36,8.36,0,0,0,.58,2.39,7.95,7.95,0,0,0,7.51,4.85h13.29l26.19.09,7.12.05,1.85,0,.63,0s-.21,0-.63,0l-1.85,0-7.12.05-26.19.08-8.68,0H477a8.36,8.36,0,0,1-7.92-5.1,9,9,0,0,1-.62-2.52c-.06-.89,0-1.72,0-2.6q0-5.19,0-10.68c0-7.31,0-15,0-22.94q0-6,0-12.14a8.33,8.33,0,0,1,8.35-8.12l47.56,0c.92,0,1.82,0,2.75.06a8.22,8.22,0,0,1,2.64.78,8.37,8.37,0,0,1,3.8,3.73,9.86,9.86,0,0,1,.89,5.09v4.95c0,6.5,0,12.56,0,18.09s0,10.52,0,14.92c0,2.19,0,4.24,0,6.12,0,.94,0,1.83,0,2.71a8.61,8.61,0,0,1-.58,2.4,8.3,8.3,0,0,1-2.47,3.28,8.17,8.17,0,0,1-2.67,1.41,7.86,7.86,0,0,1-1.83.32C526.24,384,526,384,526,384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.1,335.39h35.73l0,12h-1.7q-.85-6.42-4.81-8.69a14.9,14.9,0,0,0-6.67-1.37v31.26q0,3.29,1.14,4.35t4.77,1.08v1.5H490.46V374c2.32,0,3.86-.36,4.62-1.09s1.14-2.17,1.14-4.34V337.3a15.28,15.28,0,0,0-6.66,1.37q-4.26,2.32-4.81,8.69H483Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.25,224.16V343.82a6.43,6.43,0,0,0,6.43,6.43h77.14a6.43,6.43,0,0,0,6.43-6.43V224.16a6.43,6.43,0,0,0-6.43-6.43H551.68A6.43,6.43,0,0,0,545.25,224.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.25,224.16a1.94,1.94,0,0,1,0-.28,5.15,5.15,0,0,1,.07-.84,6.45,6.45,0,0,1,6-5.37c2.12,0,4.55,0,7.3,0l46.51-.08,15.4,0h8.2a6.67,6.67,0,0,1,6.5,4.94,7.88,7.88,0,0,1,.23,2.21v6.63c0,3,0,6,0,9.08q0,9.23,0,19c0,26,0,54.5,0,84.46a6.73,6.73,0,0,1-2.38,5.12,6.62,6.62,0,0,1-2.54,1.34,10.14,10.14,0,0,1-2.83.24H595.19l-40.74,0H552a7.31,7.31,0,0,1-2.45-.35,6.66,6.66,0,0,1-3.73-3.08,6.85,6.85,0,0,1-.77-2.31,21.3,21.3,0,0,1-.07-2.38c0-1.56,0-3.11,0-4.65q0-9.23,0-17.89c0-11.54,0-22.3,0-32.11,0-19.63.06-35.52.08-46.51,0-5.48,0-9.74.05-12.64,0-1.44,0-2.54,0-3.29s0-1.12,0-1.12,0,.38,0,1.12,0,1.85,0,3.29c0,2.9,0,7.16.05,12.64,0,11,0,26.88.08,46.51,0,9.81,0,20.57,0,32.11q0,8.66,0,17.89c0,1.54,0,3.09,0,4.65a19.54,19.54,0,0,0,.07,2.31,6.12,6.12,0,0,0,.71,2.15,6.23,6.23,0,0,0,3.47,2.86,6.78,6.78,0,0,0,2.3.32h75.73a9.54,9.54,0,0,0,2.69-.23,5.9,5.9,0,0,0,2.35-1.23,6.24,6.24,0,0,0,2.19-4.72c0-30,0-58.5,0-84.46q0-9.74,0-19,0-4.6,0-9.08v-6.63a7,7,0,0,0-.21-2.1,6.24,6.24,0,0,0-6.08-4.63h-8.2l-15.4,0-46.51-.08c-2.74,0-5.19,0-7.29,0a6.36,6.36,0,0,0-6,5.23C545.24,223.78,545.28,224.16,545.25,224.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.69,
    y: 240.73,
    width: 5.19,
    height: 87.75,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.42,328.48a2.67,2.67,0,0,0,1.64-.71c1.07-.81.64-2.77.7-5,0-4.63,0-11.27-.09-19.46s0-18-.07-28.88c0-5.43,0-11.13,0-17V243.72a4.6,4.6,0,0,0-.07-1.08,2.14,2.14,0,0,0-.48-.89,2.23,2.23,0,0,0-1.89-.72,2.17,2.17,0,0,0-1.76.91,2.09,2.09,0,0,0-.37.94,10.18,10.18,0,0,0,0,1.12v4.61q0,4.59,0,9c0,5.91,0,11.61,0,17.05,0,10.86,0,20.64-.06,28.87s-.07,14.84-.1,19.47c0,1.14,0,2.16,0,3.05a2.41,2.41,0,0,0,2.18,2.36c.3,0,.47,0,.46,0a2.32,2.32,0,0,1-.47,0,2.37,2.37,0,0,1-1.3-.45,2.52,2.52,0,0,1-1-2c0-.89,0-1.91,0-3.05,0-4.63-.05-11.27-.09-19.47s0-18-.07-28.87c0-5.44,0-11.14,0-17.05q0-4.44,0-9V244c0-.4,0-.75,0-1.2a2.71,2.71,0,0,1,.48-1.21,2.76,2.76,0,0,1,2.24-1.16,2.86,2.86,0,0,1,2.34.92,2.75,2.75,0,0,1,.61,1.14,5.4,5.4,0,0,1,.09,1.23c0,1.55,0,3.09,0,4.62v9c0,5.92,0,11.62,0,17,0,10.86,0,20.65-.06,28.88s-.07,14.83-.1,19.46c0,1.15,0,2.17,0,3.06a2.58,2.58,0,0,1-.83,2.06A2.16,2.16,0,0,1,570.42,328.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.65,
    y: 240.73,
    width: 5.19,
    height: 87.75,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.39,328.48a2.64,2.64,0,0,0,1.63-.71c1.08-.81.64-2.77.71-5,0-4.63-.06-11.27-.1-19.46s0-18-.06-28.88c0-5.43,0-11.13,0-17,0-3,0-6,0-9v-4.62a4.12,4.12,0,0,0-.07-1.08,1.94,1.94,0,0,0-.48-.89,2.21,2.21,0,0,0-1.88-.72,2.15,2.15,0,0,0-1.76.91,2.09,2.09,0,0,0-.37.94,10.05,10.05,0,0,0,0,1.12v13.64c0,5.91,0,11.61,0,17.05,0,10.86,0,20.64-.07,28.87s-.07,14.84-.09,19.47c0,1.14,0,2.16,0,3.05a2.43,2.43,0,0,0,2.18,2.36l.47,0a2.42,2.42,0,0,1-.47,0,2.39,2.39,0,0,1-1.31-.45,2.55,2.55,0,0,1-1-2c0-.89,0-1.91,0-3.05,0-4.63-.06-11.27-.1-19.47s0-18-.06-28.87c0-5.44,0-11.14,0-17.05v-9c0-1.52,0-3.06,0-4.61,0-.4,0-.75,0-1.2a2.83,2.83,0,0,1,.48-1.21,2.78,2.78,0,0,1,2.25-1.16,2.83,2.83,0,0,1,2.33.92,2.75,2.75,0,0,1,.61,1.14,4.46,4.46,0,0,1,.09,1.23v13.63c0,5.92,0,11.62,0,17,0,10.86,0,20.65-.07,28.88s-.07,14.83-.09,19.46q0,1.72,0,3.06a2.58,2.58,0,0,1-.82,2.06A2.17,2.17,0,0,1,590.39,328.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.62,
    y: 240.73,
    width: 5.19,
    height: 87.75,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.35,328.48a2.67,2.67,0,0,0,1.64-.71c1.07-.81.64-2.77.7-5,0-4.63-.05-11.27-.09-19.46s0-18-.07-28.88c0-5.43,0-11.13,0-17V243.72a4.6,4.6,0,0,0-.07-1.08,2.14,2.14,0,0,0-.48-.89,2.22,2.22,0,0,0-1.88-.72,2.17,2.17,0,0,0-1.77.91,2.09,2.09,0,0,0-.37.94,10.18,10.18,0,0,0,0,1.12v4.61q0,4.59,0,9c0,5.91,0,11.61,0,17.05,0,10.86,0,20.64-.06,28.87s-.07,14.84-.09,19.47c0,1.14,0,2.16,0,3.05a2.41,2.41,0,0,0,2.18,2.36c.3,0,.47,0,.46,0a2.32,2.32,0,0,1-.47,0,2.39,2.39,0,0,1-1.3-.45,2.52,2.52,0,0,1-1.05-2c0-.89,0-1.91,0-3.05,0-4.63,0-11.27-.09-19.47s0-18-.07-28.87c0-5.44,0-11.14,0-17.05q0-4.44,0-9V244c0-.4,0-.75,0-1.2a2.71,2.71,0,0,1,.48-1.21,2.76,2.76,0,0,1,2.25-1.16,2.84,2.84,0,0,1,2.33.92,2.75,2.75,0,0,1,.61,1.14,5.4,5.4,0,0,1,.09,1.23c0,1.55,0,3.09,0,4.62v9c0,5.92,0,11.62,0,17,0,10.86,0,20.65-.06,28.88s-.07,14.83-.1,19.46c0,1.15,0,2.17,0,3.06a2.58,2.58,0,0,1-.83,2.06A2.16,2.16,0,0,1,610.35,328.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,281.86h-1a5,5,0,0,1-5-5.05h0a5,5,0,0,1,5-5.05h1a5,5,0,0,1,5,5.05h0A5,5,0,0,1,570,281.86Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.22,300.88h-1a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h1a5,5,0,0,1,5,5h0A5,5,0,0,1,591.22,300.88Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.46,265h-1a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5.05h1a5,5,0,0,1,5,5.05h0A5,5,0,0,1,610.46,265Z",
    style: {
      fill: "#367BA0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Colors--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.1,
    y: 79.8,
    width: 123.59,
    height: 123.59,
    rx: 8.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.36,203.39s.42,0,1.23-.12a8.63,8.63,0,0,0,3.35-1.31,8.33,8.33,0,0,0,3.36-4.66,12.33,12.33,0,0,0,.3-3.72c0-1.35,0-2.78,0-4.3,0-12.15-.05-29.73-.08-51.44,0-10.86,0-22.75,0-35.52,0-3.19,0-6.44,0-9.74,0-1.64,0-3.33,0-5a8.07,8.07,0,0,0-5.83-7.25,19.24,19.24,0,0,0-5.12-.32H634.86l-93.42,0a8.08,8.08,0,0,0-8,7.36c-.08,4,0,8.14,0,12.16v23.84c0,15.63,0,30.7,0,45.06q0,10.77,0,21v5.07a8.34,8.34,0,0,0,1.13,4.66A7.51,7.51,0,0,0,536,201a7.22,7.22,0,0,0,2,1.33,9.3,9.3,0,0,0,4.61.81l35.52,0,51.44.08,14,.05,3.63,0,1.24,0-1.24,0-3.63,0-14,.05-51.44.08-35.52,0a9.79,9.79,0,0,1-4.8-.84,8.3,8.3,0,0,1-2.07-1.4,8.09,8.09,0,0,1-1.59-2,8.84,8.84,0,0,1-1.21-4.89v-5.07q0-10.2,0-21c0-14.36,0-29.43,0-45.06,0-7.81,0-15.77,0-23.84,0-4,0-8.07,0-12.21a8.61,8.61,0,0,1,8.56-7.83l93.42,0h13.25a9.05,9.05,0,0,1,2.63.34,8.55,8.55,0,0,1,6.15,7.67c.06,1.7,0,3.35,0,5q0,5,0,9.74c0,12.77,0,24.66,0,35.52,0,21.71-.07,39.29-.09,51.44,0,1.52,0,2.95,0,4.3a12.75,12.75,0,0,1-.33,3.77,8.4,8.4,0,0,1-3.46,4.7,8.3,8.3,0,0,1-3.39,1.27,6.3,6.3,0,0,1-.93.07A2.46,2.46,0,0,1,648.36,203.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.68,140.42H587.74A11.39,11.39,0,0,1,576.35,129V101.12h35.73V129A11.39,11.39,0,0,1,600.68,140.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.68,140.42a18,18,0,0,0,3.31-.61,11.59,11.59,0,0,0,3.5-1.87,11.07,11.07,0,0,0,3.29-4.13,13.07,13.07,0,0,0,1-6.43c0-2.42,0-5,0-7.8,0-5.56,0-11.77,0-18.46l.34.35-24.33,0H576.35l.36-.37c0,8.34,0,16.18,0,23.25,0,1.77,0,3.5,0,5.14a11,11,0,0,0,1.16,4.53,11.12,11.12,0,0,0,6.14,5.48c2.42.93,4.84.64,6.91.71l5.31.06,3.33.07.86,0,.29,0s-.1,0-.29,0l-.86,0-3.33.07-5.31.05-3.33,0a11.62,11.62,0,0,1-11.49-11.09c-.06-1.69,0-3.39-.05-5.17,0-7.07,0-14.91,0-23.25v-.36h11.76l24.33,0h.36v.35c0,6.69,0,12.9,0,18.46,0,2.77,0,5.38,0,7.8a13.33,13.33,0,0,1-1.17,6.61,11.25,11.25,0,0,1-3.47,4.22,11.71,11.71,0,0,1-3.63,1.82A9.33,9.33,0,0,1,600.68,140.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.53,101.39c5.2,3.79,10.56,6.28,17,6.15s13.51-2.2,18.56-6.19Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.08,106.85a4.23,4.23,0,0,1,.26.77c.16.59.36,1.33.6,2.24.52,2,1.24,4.85,2.1,8.26.44,1.75.91,3.66,1.42,5.71.24,1,.54,2,.75,3.22a6.55,6.55,0,0,1-.48,3.58,6.69,6.69,0,0,1-6.21,4.07l-8,.05h-4.06a17.44,17.44,0,0,1-4-.24,11.35,11.35,0,0,1-8.28-7c-.42-1.08-.75-2.1-1.11-3.1-.69-2-1.34-3.85-1.93-5.56l-2.75-8.07c-.29-.89-.52-1.62-.71-2.21a3.16,3.16,0,0,1-.2-.78,3.43,3.43,0,0,1,.34.73l.84,2.16,3,8,2,5.53c.76,2,1.32,4.19,2.86,5.94a10.69,10.69,0,0,0,6.1,3.62,17.42,17.42,0,0,0,3.86.21l4.06,0,8,0a6.19,6.19,0,0,0,3.41-1,6,6,0,0,0,2.18-2.61,5.91,5.91,0,0,0,.46-3.22c-.17-1-.48-2.15-.7-3.17-.48-2-.92-4-1.33-5.73-.77-3.44-1.4-6.25-1.87-8.32l-.47-2.27A2.82,2.82,0,0,1,612.08,106.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.72,108.4a2,2,0,1,1-2-2A2,2,0,0,1,581.72,108.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.7,101.48c.19.84-1,1.63-.94,2.5a3.86,3.86,0,0,1-2.48,3.67,1,1,0,0,0-.34.19,3.68,3.68,0,0,0-1,2.46l-.66,4.48a7.53,7.53,0,0,1-.74,2.7,2.57,2.57,0,0,1-2.26,1.42c-1.36-.09-2.2-1.55-2.4-2.89-.26-1.68.07-3.48-1.08-4.93a2,2,0,0,0-2.24-.75c-2,.75-.8,4-2.74,4.76a1.79,1.79,0,0,1-1.64-.24,4.65,4.65,0,0,1-1.59-3q-.66-2.62-1.31-5.27l21.45-5.11",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.67,
    cy: 165.39,
    r: 11.05,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.9,
    cy: 165.39,
    r: 11.05,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.12,
    cy: 165.39,
    r: 11.05,
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 560.67,
    cy: 165.39,
    r: 11.05,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 629.12,
    cy: 165.39,
    r: 11.05
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M571.72,165.39a22.1,22.1,0,0,0-.45-2.67,11,11,0,0,0-4-6A10.82,10.82,0,0,0,557,155.25a10.23,10.23,0,0,0-2.73,1.48A10.11,10.11,0,0,0,552,159a10.75,10.75,0,0,0,0,12.74,10.11,10.11,0,0,0,2.28,2.29,10.23,10.23,0,0,0,2.73,1.48,11,11,0,0,0,5.67.49,10.73,10.73,0,0,0,4.57-2,11,11,0,0,0,4-5.95,22.83,22.83,0,0,0,.45-2.67,8.49,8.49,0,0,1-.24,2.72,11.16,11.16,0,0,1-8.73,8.35,11.27,11.27,0,0,1-5.93-.46,10.56,10.56,0,0,1-2.86-1.53,10.88,10.88,0,0,1-2.4-2.39,11.23,11.23,0,0,1,0-13.38,10.67,10.67,0,0,1,2.4-2.39,10.29,10.29,0,0,1,2.86-1.53,11.22,11.22,0,0,1,10.65,1.67,11.05,11.05,0,0,1,4,6.22A8.49,8.49,0,0,1,571.72,165.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.94,165.39a22.1,22.1,0,0,0-.45-2.67,11,11,0,0,0-4-6,10.82,10.82,0,0,0-10.24-1.51,10.23,10.23,0,0,0-2.73,1.48,10.07,10.07,0,0,0-2.27,2.29,10.75,10.75,0,0,0,0,12.74,10.84,10.84,0,0,0,5,3.77,11,11,0,0,0,5.67.49,10.73,10.73,0,0,0,4.57-2,11,11,0,0,0,4-5.95,22.83,22.83,0,0,0,.45-2.67,8.49,8.49,0,0,1-.24,2.72,11.14,11.14,0,0,1-8.72,8.35,11.26,11.26,0,0,1-5.93-.46,10.47,10.47,0,0,1-2.87-1.53,10.63,10.63,0,0,1-2.39-2.39,11.23,11.23,0,0,1,0-13.38,11.26,11.26,0,0,1,5.26-3.92,11.14,11.14,0,0,1,14.65,7.89A8.49,8.49,0,0,1,605.94,165.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.15,165.39a22.1,22.1,0,0,0-.45-2.67,11,11,0,0,0-8.6-8,10.82,10.82,0,0,0-5.67.49,10.23,10.23,0,0,0-2.73,1.48,9.91,9.91,0,0,0-2.28,2.29,10.75,10.75,0,0,0,0,12.74,10.11,10.11,0,0,0,2.28,2.29,10.23,10.23,0,0,0,2.73,1.48,11,11,0,0,0,5.67.49,10.73,10.73,0,0,0,4.57-2,11,11,0,0,0,4-5.95,22.83,22.83,0,0,0,.45-2.67,8.49,8.49,0,0,1-.24,2.72,11.16,11.16,0,0,1-8.73,8.35,11.27,11.27,0,0,1-5.93-.46,10.56,10.56,0,0,1-2.86-1.53,10.88,10.88,0,0,1-2.4-2.39,11.23,11.23,0,0,1,0-13.38,10.67,10.67,0,0,1,2.4-2.39,10.29,10.29,0,0,1,2.86-1.53,11.22,11.22,0,0,1,10.65,1.67,11.05,11.05,0,0,1,4,6.22A8.49,8.49,0,0,1,640.15,165.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.1,193.53c.9,1.34,2.32,2.6,3.93,2.53a11.72,11.72,0,0,0,1.73-.4c.54.38.29,2.28-.13,2.79a10.38,10.38,0,0,1-1.28,1.16c1.82,1.13,3.56.74,5.6.13a9.81,9.81,0,0,1-6.31,7.5,3.45,3.45,0,0,1-3.15-.13,4,4,0,0,1-1.24-2.54A43.66,43.66,0,0,1,138.5,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.31,208.55l-2.79,45.31c-.48,7.71.4,19.12,12.62,19.32h0c10.61-.63,13.9-10.49,14.34-17.68.21-3.41.39-6.25.43-6.6,0,0,11.6-.38,13.14-11.74.74-5.5,1.35-16.93,1.78-27.29a21.36,21.36,0,0,0-18.75-22.08l-1.1-.13C106.06,186.89,98.75,196.6,98.31,208.55Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.92,248.88a27.72,27.72,0,0,1-14.28-6.2s2.59,8.76,14.08,9.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.75,212.88c-.23.22-1.5-.91-3.41-1s-3.38.72-3.57.46c-.1-.11.16-.52.81-.93a4.81,4.81,0,0,1,2.88-.66,4.57,4.57,0,0,1,2.69,1.13C117.7,212.34,117.87,212.78,117.75,212.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,218.48a1.55,1.55,0,0,1-1.68,1.37,1.48,1.48,0,0,1-1.41-1.58,1.54,1.54,0,0,1,1.67-1.37A1.49,1.49,0,0,1,117.84,218.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.89,226.42a11.45,11.45,0,0,1,2.9-.17c.46,0,.89,0,1-.32a2.26,2.26,0,0,0-.13-1.36c-.29-1.13-.59-2.32-.91-3.56-1.24-5.07-2.08-9.22-1.87-9.27s1.37,4,2.61,9.09c.3,1.25.58,2.44.85,3.58a2.58,2.58,0,0,1,0,1.78,1.12,1.12,0,0,1-.82.56,2.91,2.91,0,0,1-.77,0A11.93,11.93,0,0,1,121.89,226.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,206.88c-.25.39-1.71-.15-3.54-.33s-3.38,0-3.53-.44c-.07-.21.27-.55,1-.83a5.63,5.63,0,0,1,2.76-.35,5.75,5.75,0,0,1,2.63.93C118.37,206.28,118.62,206.69,118.51,206.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,209.68c-.21.34-1.69-.12-3.49-.27s-3.32,0-3.49-.35c-.08-.18.23-.48.88-.72a6.29,6.29,0,0,1,2.69-.31,6.45,6.45,0,0,1,2.63.79C135.49,209.17,135.76,209.52,135.66,209.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.88,216.38c-.19-.11-7.54-3.28-8.25,4.54s7.28,6.91,7.32,6.68S97.88,216.38,97.88,216.38Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.83,224.43s-.15.08-.38.17a1.37,1.37,0,0,1-1-.07c-.8-.38-1.38-1.76-1.29-3.17a4.49,4.49,0,0,1,.56-1.91,1.55,1.55,0,0,1,1.12-.95.69.69,0,0,1,.77.44c.08.23,0,.38.06.4s.18-.12.14-.45a.86.86,0,0,0-.26-.51,1,1,0,0,0-.74-.27,1.94,1.94,0,0,0-1.53,1.08,4.74,4.74,0,0,0-.67,2.14c-.09,1.58.59,3.12,1.69,3.55a1.45,1.45,0,0,0,1.26-.09C94.8,224.62,94.85,224.45,94.83,224.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09,203.19c1.77-2.68,2.31-6,3.35-9s2.92-6.15,6-7.08l.07,0c2.77-1,6.11-.81,8.24,1.18.76-4,4.48-7.09,8.51-7.93s10.36.09,14.09,1.81c2.89,1.33,5.61,3.89,8.9,7.63a39.29,39.29,0,0,1,3.76,5l2.92,10.83-3.23,5.45c-.2.37-.4.74-.64,1.11v0l-2.89,11.37c0-3.22.42-14.1.41-17.32a18,18,0,0,1-12.49-6.53c-1.66-2-2.92-4.54-5.21-5.81-3-1.65-6.61-.74-9.86.21l.15-.11a14.18,14.18,0,0,0-4.58,3,44.62,44.62,0,0,1-2.86,18.76c-.34.9-1.25,2.74-2.17,3-1.79.59-2.17-1.22-3.18-2.23a4.73,4.73,0,0,0-3.16-.94,69.45,69.45,0,0,1-1.75-8.23,7.21,7.21,0,0,1-3.3.06l1.13-2.37a3.8,3.8,0,0,1-1.44.56,1.28,1.28,0,0,1-1.3-.64C87.28,204.42,87.72,203.75,88.09,203.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27,189.83a9.9,9.9,0,0,0-1.19,1,8.08,8.08,0,0,0-1.94,3.71,13.71,13.71,0,0,0-.44,2.88c0,1.05,0,2.18,0,3.37a29.84,29.84,0,0,1-.1,3.75,12.58,12.58,0,0,1-.36,2,4,4,0,0,1-.9,1.87,1.69,1.69,0,0,1-1.63.46,2.46,2.46,0,0,1-1.41-.89,5.79,5.79,0,0,1-1-2.95l.24,0a9.76,9.76,0,0,1-1.51,2.32,3.36,3.36,0,0,1-2.28,1.1,2.24,2.24,0,0,1-1.17-.26,2,2,0,0,1-1-1.85,1.35,1.35,0,0,1,.41-.87l.11.11a7.39,7.39,0,0,1-2.54,1.72,7.73,7.73,0,0,1-.77.26l-.28.05a1.4,1.4,0,0,1,.26-.1c.18-.06.43-.15.76-.29a7.75,7.75,0,0,0,2.46-1.75l.11.11a1.49,1.49,0,0,0-.16,1.7,1.79,1.79,0,0,0,.69.73,2,2,0,0,0,1.06.22,3.16,3.16,0,0,0,2.12-1,9.46,9.46,0,0,0,1.45-2.28l.18-.36.06.4a5.81,5.81,0,0,0,.91,2.83,2.31,2.31,0,0,0,1.26.79,1.44,1.44,0,0,0,1.4-.39,3.9,3.9,0,0,0,.83-1.75,13.05,13.05,0,0,0,.35-1.93,31.14,31.14,0,0,0,.11-3.71c0-1.19,0-2.33,0-3.39a14.74,14.74,0,0,1,.47-2.92,8.1,8.1,0,0,1,2-3.73A4.49,4.49,0,0,1,109.27,189.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.05,202.68l-.1.07-.29.2c-.13.08-.3.18-.5.28a4.76,4.76,0,0,1-.71.33,10.16,10.16,0,0,1-4.93.64,12.94,12.94,0,0,1-6.77-2.88,22.39,22.39,0,0,1-5.58-7.12c-.77-1.42-1.37-2.87-2.06-4.22a15,15,0,0,0-2.38-3.6,7.82,7.82,0,0,0-3.19-2.16,5.48,5.48,0,0,0-1.72-.28,6.39,6.39,0,0,0-1.61.22,6.73,6.73,0,0,0-2.45,1.32,6.64,6.64,0,0,0-1.37,1.61,7.63,7.63,0,0,0-.67,1.68s0,0,0-.12,0-.21.07-.34a6.33,6.33,0,0,1,.5-1.27,6.53,6.53,0,0,1,1.36-1.67,6.6,6.6,0,0,1,2.5-1.39,6.71,6.71,0,0,1,1.66-.25,5.91,5.91,0,0,1,1.79.28,8,8,0,0,1,3.3,2.2,15.41,15.41,0,0,1,2.44,3.65c.69,1.36,1.3,2.81,2.05,4.22a22.69,22.69,0,0,0,5.5,7,12.89,12.89,0,0,0,6.64,2.88,10.41,10.41,0,0,0,4.87-.54C143.5,203,144,202.64,144.05,202.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.15,214.46c-.24.22-1.5-.91-3.41-1.05s-3.39.72-3.57.46.16-.52.8-.93a4.79,4.79,0,0,1,2.89-.67,4.57,4.57,0,0,1,2.69,1.14C135.1,213.91,135.27,214.36,135.15,214.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.37,220a1.54,1.54,0,0,1-1.67,1.36,1.48,1.48,0,0,1-1.42-1.58,1.56,1.56,0,0,1,1.67-1.37A1.49,1.49,0,0,1,133.37,220Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,232.82c0,.07-.45.2-1.2.11a4.65,4.65,0,0,1-2.61-1.3,4.6,4.6,0,0,1-1.3-2.6c-.09-.75,0-1.2.1-1.2s.1.45.29,1.12a5,5,0,0,0,3.6,3.59C121.32,232.73,121.77,232.74,121.78,232.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.73,257.71l-30.08,26.61-29-23.43-2.19,30.78,18,14.41c7.45,2.91,15.56,4.35,21.48-1l33.32-33.77Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.86,272.51s.7-11.58,11.06-17.67c1.51-.89,14-6.35,14-6.35l3.72-5.32,22.81,14.54,2.88,2.63,2.34-5.64,2.78,4.23-1.17-.2.32,2.16,1.42,9.35L128,297c0-.28.43,9.41.16,13.89-1,16.88-3.91,59.92-4.93,62.95a5.51,5.51,0,0,1-4.82,3.87L58.8,361c-3.37-.29-6.44-9.45-1.4-12.39Z",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.63,280.65S96.47,327,105,331.53s22.21,1.65,22.21,1.65v-3.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,260.7c3.44,1.55,35.31,43.43,35.31,43.43l45.11-.37,2.94,21.11s-47.3,6.84-58.33,4.43S71,280,69.06,276.84c-3.13-5-.46-13,4.38-17.23",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.44,259.61s-.16.18-.49.5a14.08,14.08,0,0,0-1.36,1.52,17.74,17.74,0,0,0-3.39,7,12,12,0,0,0-.07,5.58c.39,2,1.92,3.8,3.25,5.82,2.76,4,6,8.48,9.61,13.39s7.69,10.23,12.24,15.78c2.28,2.78,4.68,5.61,7.25,8.43a80.87,80.87,0,0,0,8.41,8.22,16.57,16.57,0,0,0,5.13,3.1l.35.12.38.05.76.11c.52.06,1,.16,1.54.19l3.13.14c4.22.05,8.53-.21,12.91-.5,8.76-.65,17.8-1.63,27-2.79q6.31-.78,12.47-1.65l-.22.29q-1.5-10.84-2.93-21.11l.25.22-45.11.33h-.1l-.07-.08c-10.31-13.54-18.93-24.59-25.07-32.17-3.06-3.79-5.51-6.71-7.25-8.63-.86-1-1.55-1.68-2-2.13a7,7,0,0,0-.78-.63,3.24,3.24,0,0,1,.82.58,28.42,28.42,0,0,1,2.1,2.09c1.76,1.9,4.24,4.8,7.34,8.57,6.19,7.54,14.86,18.55,25.22,32.06l-.17-.08,45.11-.42h.22l0,.22q1.42,10.25,2.94,21.11l0,.26-.26,0c-4.1.59-8.26,1.13-12.48,1.66-9.25,1.16-18.3,2.13-27.08,2.78-4.38.29-8.7.54-13,.49L117,329.9c-.53,0-1.05-.13-1.57-.2l-.78-.11-.39,0-.38-.13a16.91,16.91,0,0,1-5.3-3.2,80.86,80.86,0,0,1-8.45-8.28c-2.57-2.84-5-5.68-7.24-8.47-4.54-5.57-8.58-10.91-12.21-15.83s-6.81-9.44-9.55-13.45c-.69-1-1.35-2-2-2.91a9.1,9.1,0,0,1-1.3-3,12.39,12.39,0,0,1,.12-5.68,17.48,17.48,0,0,1,3.51-7,13.66,13.66,0,0,1,1.4-1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,248.49C92.15,249,113,263,113,263l5-4.83,2.68,2.16",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,260.34a4,4,0,0,1-.75-.51l-2-1.53h.2l-5,4.89-.14.13-.16-.1-6.3-4.23c-4.12-2.79-7.82-5.35-10.47-7.24s-4.25-3.14-4.16-3.25l14.92,10.06,6.28,4.26-.3,0,5.09-4.77.1-.09.1.09,1.93,1.64C120.49,260.09,120.72,260.31,120.7,260.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,264.16a8.33,8.33,0,0,1,.26,1.56c.13,1,.29,2.45.48,4.26.37,3.6.8,8.58,1.11,14.1s.44,10.51.45,14.14c0,1.81,0,3.27,0,4.28a9.37,9.37,0,0,1-.09,1.57,7.91,7.91,0,0,1-.11-1.57c0-1.1-.08-2.54-.13-4.28-.11-3.61-.29-8.61-.6-14.12s-.68-10.49-1-14.09c-.13-1.74-.23-3.17-.32-4.27A11.07,11.07,0,0,1,126.11,264.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,348.57a207.56,207.56,0,0,0,41.46-7.33",
    style: {
      fill: "#367BA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,341.24a8.51,8.51,0,0,1-1.57.54c-1,.32-2.5.74-4.35,1.24-3.69,1-8.83,2.18-14.57,3.2s-11,1.64-14.8,2c-1.9.17-3.44.29-4.51.34a11.68,11.68,0,0,1-1.66,0,9.77,9.77,0,0,1,1.65-.24l4.49-.49c3.78-.44,9-1.13,14.74-2.14s10.87-2.15,14.57-3l4.39-1.07A10.66,10.66,0,0,1,102.7,341.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,436.7,91.5,427S72,452.63,66.59,451.34L83.5,395.45l45,13.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.14,410.41A2.38,2.38,0,0,0,97,408a2.3,2.3,0,0,0-2.37,2.09,2.52,2.52,0,0,0,2.27,2.49c1.17-.05,2.45-1.29,2.22-2.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,395.05l4.36,1.29L70.1,450s-1.84,2.17-3.51,1.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.51,428c-.27-.09,0-1.49-.46-3.1s-1.4-2.67-1.22-2.89,1.64.66,2.18,2.62S91.74,428.08,91.51,428Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,433.08c-.29,0-.39-1.34-1.27-2.62s-2-1.91-1.92-2.18,1.69,0,2.75,1.63S87.57,433.15,87.31,433.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,434.29c0-.27,1.5-.24,2.78.92s1.49,2.61,1.23,2.65-.82-1-1.89-1.91S79.23,434.57,79.28,434.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.24,429.45c-.21-.19.54-1.33.9-2.9s.24-2.93.52-3,.9,1.38.45,3.23S98.42,429.65,98.24,429.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.44,360.76c1.09-.3,49.32,51.44,50.42,60s-.66,16-6.36,20.82-70.59-11-70.59-11l6.14-27.18-23.46-7.89,21-38.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.84,372.23l1.55,1.66s-27.65,29-36.13,28.6l-13.57-4.6,45.92-28.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,404.14c0,.13,10,3.22,22.48,6.88S148,417.53,148,417.4s-10-3.23-22.49-6.89S102.93,404,102.89,404.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17,413.58l-8.48,26.91s24.5,17.65,23.41,22.78L119.34,448.7l11.5-42.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,433.69a2.24,2.24,0,0,0-2.17,2.05,2.16,2.16,0,0,0,2,2.17,2.37,2.37,0,0,0,2.29-2.18c-.08-1.1-1.27-2.27-2.34-2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,449.8l1.11-4.12L170.76,460s2.07,1.67,1.34,3.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,440.45c-.08.26-1.4,0-2.9.5s-2.47,1.37-2.68,1.21.59-1.55,2.41-2.1S149.74,440.23,149.62,440.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.52,444.27c0,.27-1.25.4-2.43,1.24s-1.74,1.94-2,1.85,0-1.58,1.47-2.61S154.58,444,154.52,444.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,451.76c-.25,0-.25-1.39.8-2.62s2.41-1.46,2.46-1.21-.9.79-1.75,1.81S156.09,451.81,155.83,451.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.87,434.11c-.17.2-1.26-.48-2.74-.78s-2.75-.16-2.82-.42,1.27-.87,3-.49S151.05,433.94,150.87,434.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.89 436.02 124.48 421.92 121.81 420.68 138.12 376.27 141.24 378.98 128.42 419.66 123.83 436.64 120.89 436.02"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,361S155.22,327.36,157,326.7a20.33,20.33,0,0,1,2.41-.61A22.93,22.93,0,0,1,177.75,330c4.38,3.28,8,8.55,6.85,16.84-2.63,18.41-26.17,81.27-26.17,81.27l-32.56-9.79c-.18-.05-.37-.59-.26-.43.26.43,16.52-51.93,16.11-51.32s-32.86,26.82-46.34,31.63A29.87,29.87,0,0,1,61.25,388C58.09,383.63,55.42,371.19,58.8,361Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,361s-.12.33-.33,1a29.09,29.09,0,0,0-.75,3.08,38.88,38.88,0,0,0-.17,12.16,33,33,0,0,0,2.28,8.52,13.84,13.84,0,0,0,1.19,2.2c.49.69,1,1.36,1.58,2a27.49,27.49,0,0,0,4,3.77,29.87,29.87,0,0,0,10.78,5.4,28.45,28.45,0,0,0,6.54,1,28.94,28.94,0,0,0,7-.5l1.77-.38c.58-.14,1.16-.34,1.75-.52a31.07,31.07,0,0,0,3.46-1.32c1.14-.51,2.25-1.12,3.4-1.68l3.36-1.91c4.47-2.66,9-5.68,13.56-8.9s9.24-6.68,14-10.33q3.56-2.73,7.15-5.63l1.79-1.48c.15-.13.3-.23.45-.38l.24-.22.12-.12c-.18,0,.48,0-.39-.1,0-.18,0,0,0-.06-.09.36-.2.74-.31,1.11-.44,1.49-.89,3-1.35,4.51-3.69,12.08-7.64,24.76-11.84,37.89l-1.61,4.93c-.28.82-.55,1.66-.85,2.46,0,.07-.12.25-.08.21.84.35.27-.52-.12.23l0,.13a1.51,1.51,0,0,0,.09.18.66.66,0,0,0,.38.35l.32.09,1.26.38,10.16,3.06,20.79,6.25.25.08.09-.24c1.08-2.92,2.23-6.06,3.39-9.21,5.2-14.32,10.14-28.35,14.56-42,2.19-6.84,4.31-13.58,6.06-20.27.46-1.67.81-3.35,1.22-5s.66-3.35,1-5a17.13,17.13,0,0,0-7.68-17.34,22.4,22.4,0,0,0-8.83-3.61,23.87,23.87,0,0,0-9.27.19l-2.23.57-2.12.74-4.2,1.47-30.84,10.8c-18.83,6.61-34.07,11.95-44.61,15.66L63,359.43l-3.14,1.12-1.05.4,1.09-.36,3.18-1.08,12.17-4.19,44.67-15.49,30.82-10.71,4.18-1.45,2.13-.74,2.16-.55a23.48,23.48,0,0,1,9.08-.17,21.76,21.76,0,0,1,8.64,3.54,16.64,16.64,0,0,1,7.44,16.87c-.29,1.65-.56,3.32-1,5s-.76,3.33-1.22,5c-1.76,6.67-3.87,13.4-6.07,20.23-4.42,13.67-9.36,27.69-14.56,42l-3.38,9.2.33-.16-20.79-6.25-10.17-3.06-1.26-.38-.31-.09s-.1.22,0,0,0,0,0,0l-.06-.09a.37.37,0,0,1,0-.11c-.07,0,.11-.06-.14,0,0,0-.85.26.1.21a1.6,1.6,0,0,0,.19-.38c.31-.84.58-1.66.86-2.49q.81-2.48,1.61-4.94c4.2-13.14,8.13-25.82,11.81-37.91.46-1.51.9-3,1.35-4.51.11-.38.22-.74.31-1.14,0-.07,0,0,0-.2-.86-.11-.3,0-.49,0l-.09.09-.2.17c-.12.12-.29.25-.43.37L139,368.6q-3.57,2.89-7.13,5.63-7.09,5.47-14,10.34c-4.58,3.23-9.06,6.25-13.51,8.91L101,395.39c-1.13.56-2.23,1.17-3.36,1.67a30.47,30.47,0,0,1-3.42,1.32c-.58.17-1.15.38-1.73.52l-1.74.38a28.73,28.73,0,0,1-6.87.51,29.12,29.12,0,0,1-6.48-1,29.91,29.91,0,0,1-10.68-5.31,28,28,0,0,1-3.94-3.71c-.55-.67-1.09-1.34-1.57-2a12.77,12.77,0,0,1-1.17-2.14,32.53,32.53,0,0,1-2.31-8.45,39.52,39.52,0,0,1,.07-12.11c.26-1.36.48-2.4.69-3.08S58.8,361,58.8,361Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,352.19a12.81,12.81,0,0,0-2.68,1.5,40.36,40.36,0,0,0-5.82,4.61,36.43,36.43,0,0,0-4.84,5.64,22.48,22.48,0,0,0-1.19,1.91,2.54,2.54,0,0,0-.34.75,29.1,29.1,0,0,0,1.83-2.45,46.92,46.92,0,0,1,4.9-5.47,55.93,55.93,0,0,1,5.67-4.69A25,25,0,0,0,156.59,352.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,348.56a11.67,11.67,0,0,0-1.15,2.46,44.39,44.39,0,0,0-1.89,6.27,45.08,45.08,0,0,0-.94,6.49,11.8,11.8,0,0,0,0,2.71,18.16,18.16,0,0,0,.38-2.67c.2-1.66.54-3.93,1.09-6.41s1.21-4.68,1.72-6.26A18.71,18.71,0,0,0,145.48,348.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,299.43l12.34-24.93a5,5,0,0,1,4.47-2.77h31a1.52,1.52,0,0,1,1.34,2.23l-21,38.85a3.39,3.39,0,0,1-3,1.76H178.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,274.14a3,3,0,0,1-.62.05l-1.77,0h-6.53L204,274a6.2,6.2,0,0,0-2.87.68,5.4,5.4,0,0,0-1.9,2.09c-.9,1.7-1.66,3.48-2.44,5.1-1.54,3.26-2.93,6.2-4.12,8.7l-2.81,5.84-.8,1.57a2,2,0,0,1-.31.53A2.37,2.37,0,0,1,189,298l.69-1.62c.66-1.47,1.56-3.47,2.65-5.92l4-8.74c.78-1.64,1.5-3.37,2.43-5.16a5.88,5.88,0,0,1,2.11-2.3,6.65,6.65,0,0,1,3.13-.77c8.44.05,16,.24,21.55.35l6.53.18,1.77.08A2.74,2.74,0,0,1,234.48,274.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.38,279.6a1,1,0,0,1,.46,1.54,1.47,1.47,0,0,1-1.64.62,1.14,1.14,0,0,1-.85-.82,1.43,1.43,0,0,1,1-1.42A2.28,2.28,0,0,1,215.38,279.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.58,309l2.14-2.18s3.14-4.53,4.42-5.94,9-6.37,9-6.37,3.71-5,4.28-5,2.38.32,1.89,2.64a35,35,0,0,1-2,6.7l16.46.35a3.54,3.54,0,0,1,2.68,1.28c.43.54.61,1.14-.16,1.52-1.72.85-8.71,2.55-8.71,2.55l3.12-.8s.67,3-1.3,4.37a11.18,11.18,0,0,0-2.1,1.66s-.1,2.81-1,3.94-10.12,5.86-10.12,5.86-5.93,1.74-8.92,1.59-6.08,1.55-6.42,1.64S166.58,309,166.58,309Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,299a35.44,35.44,0,0,1-4.62.51c-2.54.28-4.65.41-4.66.23a19.91,19.91,0,0,1,4.6-.8A13.18,13.18,0,0,1,187.85,299Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.66,306.21c-.06-.17,3-1,6.72-1.42,1.88-.23,3.58-.4,4.81-.54a9,9,0,0,1,2-.15,5.7,5.7,0,0,1-1.94.56c-1.23.24-2.93.47-4.81.71C188.69,305.79,185.69,306.34,185.66,306.21Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.66,311.55c0-.17,2.39-.24,5.29-.74s5.19-1.21,5.24-1.05a19.75,19.75,0,0,1-10.53,1.79Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.65,317.53c-.16,0-.4-.61-.53-1.43s-.12-1.5,0-1.53.39.62.53,1.44S186.81,317.51,186.65,317.53Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.18,310.37c-.17,0-.26-.54-.54-1.1s-.63-1-.54-1.1.71.12,1.07.84S185.33,310.4,185.18,310.37Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,303.2c-.17,0-.33-.33-.53-.71s-.37-.73-.26-.85.53.1.78.59S183.45,303.19,183.3,303.2Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,257.76s.36-4.68,2.79-7.66c6.36-7.82,4.24-14.79,4.24-14.79,2.21-2.44,5.87.47,6.58,6,1.49,11.57-.49,24.6-.61,25.08s-6.74,3.42-6.74,3.42l-8.79-10.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 187.61,
    width: 165.56,
    height: 80.77,
    rx: 8.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,268.39s.42,0,1.23-.13a8.3,8.3,0,0,0,3.34-1.25,8.59,8.59,0,0,0,3.54-4.51,9.85,9.85,0,0,0,.45-3.68c0-1.34,0-2.76,0-4.27,0-12.1-.05-29.59-.08-51.2,0-1.35,0-2.72,0-4.1v-2.09a14.36,14.36,0,0,0-.09-2.08,8.47,8.47,0,0,0-4.86-6.5,9.33,9.33,0,0,0-4.27-.76H340.55l-40.57,0-93,0a8.46,8.46,0,0,0-5.49,2A8.26,8.26,0,0,0,198.7,195a21.27,21.27,0,0,0-.11,3v32.81q0,11.67,0,22.9v5.58a8.67,8.67,0,0,0,1.41,5.1,8.44,8.44,0,0,0,4.1,3.22c1.65.68,3.45.5,5.24.53l75.94.05,51.2.09,13.92,0,3.62,0,1.23,0s-.42,0-1.23,0l-3.62,0-13.92.05-51.2.08-75.94.06c-.89,0-1.78,0-2.69,0a8.42,8.42,0,0,1-2.72-.53,9,9,0,0,1-4.34-3.41,9.11,9.11,0,0,1-1.49-5.37v-5.58q0-11.22,0-22.9c0-7.77,0-15.69,0-23.72V198a24.73,24.73,0,0,1,.11-3.08,8.85,8.85,0,0,1,3-5.41,9,9,0,0,1,5.83-2.17l93,0,40.57,0h13.93a9.61,9.61,0,0,1,4.43.81A8.84,8.84,0,0,1,364,195a14,14,0,0,1,.09,2.13v6.19c0,21.61-.07,39.1-.09,51.2,0,1.51,0,2.93,0,4.27a10.17,10.17,0,0,1-.48,3.73,8.7,8.7,0,0,1-3.63,4.55,8.45,8.45,0,0,1-3.4,1.22,7.82,7.82,0,0,1-.92.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.51 225.39 238.51 236.05 263.61 246.81 263.83 236.61 249.8 230.35 263.83 224.37 263.83 214.49 238.51 225.39",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.71 236.76 323.71 226.11 298.39 215.34 298.18 225.54 312.33 231.8 298.18 237.79 298.18 247.67 323.71 236.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.57,205.69c0,.27-14.74,50-14.32,49.92s11,0,11,0l14.54-49.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,198.33a3.5,3.5,0,1,1-3.49-3.28A3.38,3.38,0,0,1,215.55,198.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.13,198.33a3.49,3.49,0,1,1-3.49-3.28A3.38,3.38,0,0,1,225.13,198.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,198.33a3.49,3.49,0,1,1-3.48-3.28A3.38,3.38,0,0,1,234.71,198.33Z",
    style: {
      fill: "#e0e0e0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.2744448c19d7d04ca76e3004a1c68c10.svg";
export { ForwardRef as ReactComponent };